import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * Lets the global topbar (one instance, outside the router-outlet) trigger the Advanced Search
 * panel owned by whichever page is currently routed (each page embeds its own
 * sidebar-notification-cmp instance with its own searchType), and lets that page report back
 * whether it actually has an Advanced Search to offer, so the topbar can hide its button on
 * screens that don't (reports, dashboards, etc.).
 */
@Injectable({ providedIn: 'root' })
export class AdvancedSearchBridgeService {
    private readonly _openRequested = new Subject<void>();
    readonly openRequested$ = this._openRequested.asObservable();

    private readonly _available = new BehaviorSubject<boolean>(false);
    readonly available$ = this._available.asObservable();

    /** Whether the Advanced Search dialog (the full-viewport #search-bar) is actually open right
     * now. Reported by the sidebar-notification-cmp instance itself (not inferred from
     * requestOpen(), since a page can have Advanced Search unavailable/hidden), so AppShellComponent
     * can hide the topbar for exactly as long as the dialog is on screen. */
    private readonly _isOpen = new BehaviorSubject<boolean>(false);
    readonly isOpen$ = this._isOpen.asObservable();

    requestOpen(): void {
        this._openRequested.next();
    }

    setAvailable(available: boolean): void {
        this._available.next(available);
    }

    setOpen(isOpen: boolean): void {
        this._isOpen.next(isOpen);
    }
}
